export default __webpack_public_path__ + "static/media/bridgewater.9c0f4512.svg";